import { IApiError } from '@frontend/request';

import { accountExperienceAPIController } from '@aqx-core/common/api/account-experience';
import { mapResponseCodeToMessage } from '@aqx-core/common/request';

import { resetPasswordExperienceService } from './service';
import { EResetPasswordExperienceContent, IResetPasswordParams } from './types';

class ResetPasswordExperienceViewController {
  public reset = () => {
    resetPasswordExperienceService.reset();
  };

  public resetPassword = async ({ params, onError }: IResetPasswordParams) => {
    resetPasswordExperienceService.setLoading(true);
    await accountExperienceAPIController
      .resetPassword(params, {
        onSuccess: (res) => {
          if (res) {
            resetPasswordExperienceService.setDetails(res);
            resetPasswordExperienceService.setContent(EResetPasswordExperienceContent.COMPLETE);
          }
        },
        onError: (error) => {
          const { code, message } = error as IApiError;
          onError(mapResponseCodeToMessage(code, message));
        }
      })
      .finally(() => {
        resetPasswordExperienceService.setLoading(false);
      });
  };
}

export const resetPasswordExperienceViewController = new ResetPasswordExperienceViewController();
